module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-7-cc7ea518bf188f50464f27aa69628c66.jpg";